import React from 'react';
import { Box, Typography } from '@mui/material';

const hexPattern = /^#[0-9a-fA-F]{6}$/;

export default function ColorPickerField({
  value = '#000000',
  onChange,
  label,
  fullWidth,
  sx,
  placeholder = 'Pick the color',
}) {
  const safe = hexPattern.test(value || '') ? value.toUpperCase() : '#000000';

  return (
    <Box sx={{ width: fullWidth ? '100%' : 200, ...sx }}>
      {label ? <Typography variant="caption" sx={{ color: 'text.secondary', ml: 0.5 }}>{label}</Typography> : null}
      <Box sx={{ display: 'flex', alignItems: 'center', borderRadius: 1.5, overflow: 'hidden', bgcolor: '#eef1f5', border: '1px solid #d8dde6', height: 42 }}>
        <Box sx={{ position: 'relative', width: 40, minWidth: 40, height: '100%', bgcolor: safe }}>
          <Box
            component="input"
            type="color"
            value={safe}
            onChange={(e) => onChange?.({ target: { value: e.target.value.toUpperCase() } })}
            sx={{ position: 'absolute', inset: 0, opacity: 0, cursor: 'pointer', p: 0, border: 0 }}
          />
        </Box>
        <Box
          component="input"
          value={safe}
          placeholder={placeholder}
          onChange={(e) => onChange?.({ target: { value: e.target.value.toUpperCase() } })}
          sx={{ flex: 1, height: '100%', border: 0, outline: 0, px: 1.5, fontSize: 18, letterSpacing: 0.4, color: '#3f4654', background: 'transparent' }}
        />
      </Box>
    </Box>
  );
}
